module.exports = __webpack_public_path__ + "static/pegasus_banner-ca3eec3669de07f72f3e102bafbe9e8d.png";